import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [ip, setIp] = useState('Buscando seu IP...');

  useEffect(() => {
    const fetchIp = async () => {
      try {
        // Use a lógica que preferir para buscar o IP; aqui usamos um exemplo básico:
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setIp(data.ip);
      } catch (error) {
        setIp('Erro ao obter o IP');
      }
    };

    fetchIp();
  }, []);

  return (
      <div class="px-4 py-5 my-5 text-center">
        <img className="d-block mx-auto mb-4" src="58702.jpg" alt=""   height="300px"/>
        <h1 class="display-5 fw-bold text-body-emphasis">Você está conectado à internet com o IP:<br/> {ip} </h1>
        <div class="col-lg-6 mx-auto">

        </div>
      </div>

  );
}

export default App;
